import React, { Component } from 'react';
//import { Container, Row, Col,Form } from 'react-bootstrap';
import ServiceCalls from '../utils/serviceCalls.js';
import RoleUtils from '../utils/roleUtils.js';
import { VendorTable } from '../components/VendorTable';
import RemitAddressesTable from '../components/RemitAddressesTable';
import { Link } from 'react-router-dom';
import '../styles/Vendor.css';
import { Loading } from '../components/Loading';
export class RemitAddresses extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = {
            hasAccess: false,
            isLoading: true,
            vendorData: {},
            isReadOnly:true
        };
    }
    componentDidMount() {
        //const { currentCompanyId } = this.props;
        this.onChange();
    }

    componentDidUpdate(prevProps, prevState) {
        const { currentCompanyId } = this.props;
        if (prevProps.currentCompanyId !== currentCompanyId) {
            this.setState({
                hasAccess: false,
                isLoading: true,
                vendorData: {}
            });
            this.onChange();
        }
    }  

    onChange() {
        const { currentCompanyId,currentUser } = this.props;
        
        this.setState({
            isLoading: true,           
        });

        ServiceCalls.checkVendorAccess(Number(currentCompanyId)).then(function (data) {
            if (data) {              
                ServiceCalls.getVendorInfo(Number(currentCompanyId)).then(function (results) {
                    var readOnly = !(results.status === 'A') || !(RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.profileEditNoBankRoles()));
                    if (results) {                       
                        this.setState({
                            hasAccess: data,
                            isLoading: false,
                            vendorData: results,
                            isReadOnly:readOnly
                        });
                    }
                    else {
                        this.setState({
                            hasAccess: data,
                            isLoading: false,
                            isReadOnly: readOnly
                        });
                    }
                }.bind(this));
            }
            else {
                this.setState({ hasAccess: false, isLoading: false });
            }
        }.bind(this));
    }

    render() {
        const { currentCompanyId, currentUser } = this.props;
        const { hasAccess, isLoading,vendorData,isReadOnly } = this.state;
        const supplierUrl = <Link to="/Profile/Supplier">
            <span>Return to Supplier Profile</span>
        </Link>;
        const vendorForm = (isLoading)
            ? <div style={{ margin: "auto", width: "250px" }}>
                <h3 className="primaryText">Remit Addresses</h3>
                <Loading />
            </div>
            :(hasAccess === true && vendorData) ?
            <>
                <VendorTable currentCompanyId={currentCompanyId} currentUser={currentUser} vendorData={vendorData} showAll={false} title="Remit Addresses" returnUrl={supplierUrl} /> 
                <RemitAddressesTable vendorData={vendorData} isReadOnly={isReadOnly}  onAddressChange={this.onChange} />
            </>
            :  <h3 style={{ marginTop: "10px" }}>You do not have access rights to this page.</h3>;

        return (
            <>
                {vendorForm}
            </>
        );
    }
}
